// extracted by mini-css-extract-plugin
module.exports = {"loading":"PdfModalBase__loading--34K6d","button":"PdfModalBase__button--hOIfU"};